import React, { Fragment, useState, useMemo } from 'react';
import { Button } from 'antd';
import { connect } from 'dva';

const AuthButton = props => {
  const [loading, setLoading] = useState(false);

  const {
    authCode = '',
    authCodeList,
    disabled,
    ghost,
    href,
    htmlType,
    icon,
    shape,
    size,
    target,
    type,
    onClick: propsOnClick,
    block,
    danger,
    className,
  } = props;
  const antdProps = {
    disabled,
    ghost,
    href,
    htmlType,
    icon,
    shape,
    size,
    target,
    type,
    block,
    danger,
    className,
  };
  const hasAuth = useMemo(() => authCodeList.indexOf(authCode) > -1 || !authCode, [authCodeList, authCode]);

  const onClick = async () => {
    if (propsOnClick) {
      setLoading(true);
      await propsOnClick();
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {hasAuth && (
        <Button {...antdProps} onClick={onClick} loading={loading}>
          {props.children}
        </Button>
      )}
    </Fragment>
  );
};

const mapStateToProps = state => {
  return { authCodeList: state.userInfo.code_list };
};

export default connect(mapStateToProps)(AuthButton);
